export default{name:"goback-btn",methods:{nextView:function nextView(){this.$store.commit("prevView")}},computed:{title:function title(){var v=this.$store.getters.prevView;if(v==="uprights"&&this.$store.state.configurator==="krossing")return this.$t("krossing_02_step");else return this.$t(v)},number:function number(){var offset=this.$store.state.viewOffset-1;return"0"+offset},isVisible:function isVisible(){return this.$store.state.viewOffset>0},isActive:function isActive(){return this.$store.state.prev_btn_active}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/GoBackBtn.vue
// module id = 249
// module chunks = 0